"use strict";
/*This is a modified version of https://github.com/samcrosoft/waveformjs, the original one is written in coffee script, and I rewrite it into typescript*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Waveform = exports.EVENT_RESIZED = exports.EVENT_HOVER = exports.EVENT_CLICK = exports.EVENT_READY = exports.REFLECTION_ACTIVE = exports.REFLECTION = exports.GUTTER_SELECTED = exports.GUTTER_ACTIVE = exports.GUTTER = exports.WAVE_SELECTED = exports.WAVE_ACTIVE = exports.WAVE = exports.WAVE_FOCUS = exports.DEFAULT_MIN_OPACITY = exports.DEFAULT_MAX_OPACITY = void 0;
var event_emitter_1 = require("./event-emitter");
exports.DEFAULT_MAX_OPACITY = 1;
exports.DEFAULT_MIN_OPACITY = 0.2;
exports.WAVE_FOCUS = 'waveFocus';
exports.WAVE = 'wave';
exports.WAVE_ACTIVE = 'waveActive';
exports.WAVE_SELECTED = 'waveSelected';
exports.GUTTER = 'gutter';
exports.GUTTER_ACTIVE = 'gutterActive';
exports.GUTTER_SELECTED = 'gutterSelected';
exports.REFLECTION = 'reflection';
exports.REFLECTION_ACTIVE = 'reflectionActive';
exports.EVENT_READY = "ready";
exports.EVENT_CLICK = "click";
exports.EVENT_HOVER = "hover";
exports.EVENT_RESIZED = "hover";
var Waveform = /** @class */ (function (_super) {
    __extends(Waveform, _super);
    function Waveform(options) {
        var _this = _super.call(this) || this;
        _this.DEFAULT_MAX_OPACITY = exports.DEFAULT_MAX_OPACITY;
        _this.DEFAULT_MIN_OPACITY = exports.DEFAULT_MIN_OPACITY;
        _this.WAVE_FOCUS = exports.WAVE_FOCUS;
        _this.WAVE = exports.WAVE;
        _this.WAVE_ACTIVE = exports.WAVE_ACTIVE;
        _this.WAVE_SELECTED = exports.WAVE_SELECTED;
        _this.GUTTER = exports.GUTTER;
        _this.GUTTER_ACTIVE = exports.GUTTER_ACTIVE;
        _this.GUTTER_SELECTED = exports.GUTTER_SELECTED;
        _this.REFLECTION = exports.REFLECTION;
        _this.REFLECTION_ACTIVE = exports.REFLECTION_ACTIVE;
        _this.EVENT_READY = exports.EVENT_READY;
        _this.EVENT_CLICK = exports.EVENT_CLICK;
        _this.EVENT_HOVER = exports.EVENT_HOVER;
        _this.EVENT_RESIZED = exports.EVENT_RESIZED;
        _this.data = [];
        _this.outerColor = 'transparent';
        _this.reflection = 0;
        _this.interpolate = true;
        _this.bindResize = false;
        _this.fadeOpacity = 0.5;
        _this.wavesCollection = [];
        _this.width = 0;
        _this.height = 0;
        _this.waveWidth = 2;
        _this.gutterWidth = 1;
        _this.waveOffset = 0;
        _this.reflectionHeight = 0;
        _this.waveHeight = 0;
        _this.colors = {};
        _this.active = -1;
        _this.clickPercent = 0;
        _this.selected = -1;
        _this.isPlaying = false;
        _this.hasStartedPlaying = false;
        _this.trackLength = 0;
        Object.assign(_this, options);
        if (!_this.canvas) {
            if (_this.container) {
                _this.spawnCanvas(options.width || _this.container.clientWidth, options.height || _this.container.clientHeight);
                _this.width = parseInt(_this.context.canvas.width.toString(), 10);
                _this.height = parseInt(_this.context.canvas.height.toString(), 10);
            }
            else {
                throw 'Either canvas or container option must be passed';
            }
        }
        _this.fadeOpacity = _this.fadeOpacity || _this.DEFAULT_MAX_OPACITY;
        if (isNaN(_this.fadeOpacity)) {
            throw new Error('Fade Opacity Can Only Be A Number');
        }
        else if (_this.fadeOpacity < _this.DEFAULT_MIN_OPACITY || _this.fadeOpacity > _this.DEFAULT_MAX_OPACITY) {
            throw new Error("Fade Opacity Can Only Be A Number Between " + _this.DEFAULT_MIN_OPACITY + " and " + _this.DEFAULT_MAX_OPACITY);
        }
        _this.initialize();
        return _this;
    }
    Waveform.prototype.spawnCanvas = function (width, height) {
        this.canvas = document.createElement("canvas");
        this.container.appendChild(this.canvas);
        this.canvas.width = width;
        this.canvas.height = height;
        this.context = this.canvas.getContext('2d');
    };
    ;
    Waveform.prototype.initialize = function () {
        this.updateHeight();
        this.setColors();
        this.bindEventHandlers();
        this.cache();
        this.redraw();
        if (this.bindResize === true) {
            this.bindContainerResize();
        }
        this.fireEvent(this.EVENT_READY);
    };
    ;
    Waveform.prototype.updateHeight = function () {
        this.waveOffset = Math.round(this.height - (this.height * this.reflection));
        this.reflectionHeight = Math.round(this.height - this.waveOffset);
        this.waveHeight = this.height - this.reflectionHeight;
    };
    ;
    Waveform.prototype.setColors = function () {
        this.setColor(this.WAVE_FOCUS, '#333333');
        this.setGradient(this.WAVE, [{ color: '#666666', offset: 0 }, { color: '#868686', offset: 1 }]);
        this.setGradient(this.WAVE_ACTIVE, [{ color: '#FF3300', offset: 0 }, { color: '#FF5100', offset: 1 }]);
        this.setGradient(this.WAVE_SELECTED, [{ color: '#993016', offset: 0 }, { color: '#973C15', offset: 1 }]);
        this.setGradient(this.GUTTER, [{ color: '#6B6B6B', offset: 0 }, { color: '#c9c9c9', offset: 1 }]);
        this.setGradient(this.GUTTER_ACTIVE, [{ color: '#FF3704', offset: 0 }, { color: '#FF8F63', offset: 1 }]);
        this.setGradient(this.GUTTER_SELECTED, [{ color: '#9A371E', offset: 0 }, { color: '#CE9E8A', offset: 1 }]);
        this.setColor(this.REFLECTION, '#999999');
        this.setColor(this.REFLECTION_ACTIVE, '#FFC0A0');
    };
    Waveform.prototype.setColor = function (name, color) {
        this.colors[name] = color;
    };
    Waveform.prototype.setGradient = function (name, colorObjs) {
        var gradient, i;
        gradient = this.context.createLinearGradient(0, this.waveOffset, 0, 0);
        i = 0;
        while (i < colorObjs.length) {
            gradient.addColorStop(colorObjs[i].offset, colorObjs[i].color);
            i += 1;
        }
        this.colors[name] = gradient;
    };
    ;
    Waveform.prototype.getMouseClickPosition = function (evt) {
        var canvas, rect, x, y;
        canvas = this.canvas;
        rect = canvas.getBoundingClientRect();
        x = Math.round((evt.clientX - rect.left) / (rect.right - rect.left) * canvas.width);
        y = Math.round((evt.clientY - rect.top) / (rect.bottom - rect.top) * canvas.height);
        return [x, y];
    };
    ;
    Waveform.prototype.fireEvent = function (name) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        this.trigger(name, data);
    };
    ;
    Waveform.prototype.bindEventHandlers = function () {
        this.canvas.addEventListener('mousedown', this.onMouseDown.bind(this));
        this.canvas.addEventListener('mousemove', this.onMouseOver.bind(this));
        this.canvas.addEventListener('mouseout', this.onMouseOut.bind(this));
    };
    ;
    Waveform.prototype.onMouseOut = function (e) {
        this.selected = -1;
        this.redraw();
    };
    ;
    Waveform.prototype.onMouseOver = function (e) {
        var aPos, //coordinate in [x,y] format
        mousePosTrackTime, waveClicked, x;
        if (this.hasStartedPlaying === true && this.isPaused() === true) {
            return true;
        }
        aPos = this.getMouseClickPosition(e);
        x = aPos[0];
        waveClicked = this.getWaveClicked(x);
        mousePosTrackTime = this.getMousePosTrackTime(x);
        this.fireEvent(this.EVENT_HOVER, mousePosTrackTime, waveClicked);
        this.selected = waveClicked;
        this.redraw();
    };
    ;
    Waveform.prototype.onMouseDown = function (e) {
        var aPos, //coordinate in [x,y] format
        x;
        aPos = this.getMouseClickPosition(e);
        x = aPos[0];
        this.clickPercent = x / this.width;
        this.fireEvent(this.EVENT_CLICK, this.clickPercent * 100);
        this.active = this.calcPercent();
        this.redraw();
    };
    ;
    Waveform.prototype.bindContainerResize = function () {
        var _this = this;
        window.addEventListener("resize", function () {
            return function () {
                var iContWidth;
                iContWidth = _this.container.clientWidth;
                _this.update({
                    width: iContWidth
                });
                _this.redraw();
                return _this.trigger(_this.EVENT_RESIZED, [iContWidth]);
            };
        });
    };
    ;
    Waveform.prototype.setPlaying = function (val) {
        if (val === void 0) { val = true; }
        this.isPlaying = val;
    };
    ;
    Waveform.prototype.setPaused = function () {
        this.setPlaying(false);
    };
    ;
    Waveform.prototype.isPaused = function () {
        return this.active > 0 && this.isPlaying === false;
    };
    ;
    Waveform.prototype.play = function (perct) {
        this.playProgress(perct);
    };
    ;
    Waveform.prototype.pause = function () {
        this.setPaused();
        console.log("is paused is ", this.isPaused());
    };
    ;
    Waveform.prototype.playProgress = function (perct) {
        var iActive;
        if (this.hasStartedPlaying === null) {
            this.hasStartedPlaying = true;
        }
        if (this.isPlaying === false) {
            this.setPlaying(true);
        }
        iActive = Math.round((perct / 100) * this.wavesCollection.length);
        this.active = iActive;
        this.redraw();
    };
    ;
    Waveform.prototype.calcPercent = function () {
        return Math.round(this.clickPercent * this.width / (this.waveWidth + this.gutterWidth));
    };
    ;
    Waveform.prototype.getWaveClicked = function (x) {
        var fReturn, waveClicked;
        waveClicked = Math.round(x / (this.waveWidth + this.gutterWidth));
        fReturn = 0;
        if (waveClicked > this.wavesCollection.length) {
            fReturn = this.wavesCollection.length;
        }
        else if (waveClicked < 0) {
            fReturn = 0;
        }
        else {
            fReturn = waveClicked;
        }
        return fReturn;
    };
    ;
    Waveform.prototype.getMousePosTrackTime = function (x) {
        var fReturn, mousePosTrackTime;
        mousePosTrackTime = this.trackLength / this.wavesCollection.length * this.getWaveClicked(x);
        fReturn = 0;
        if (mousePosTrackTime > this.trackLength) {
            fReturn = this.trackLength;
        }
        else if (mousePosTrackTime < 0) {
            fReturn = 0;
        }
        else {
            fReturn = mousePosTrackTime;
        }
        return fReturn;
    };
    ;
    Waveform.prototype.redraw = function () {
        requestAnimationFrame(this.render.bind(this));
    };
    ;
    Waveform.prototype.render = function () {
        var d, dNext, gutterX, i, j, len, ref, reflectionHeight, results, t, xPos, yPos;
        i = 0;
        ref = this.wavesCollection;
        t = this.width / this.data.length;
        xPos = 0;
        yPos = this.waveOffset;
        this.clear();
        j = 0;
        len = ref.length;
        results = [];
        while (j < len) {
            d = ref[j];
            dNext = ref[j + 1];
            /*
            Draw the wave here
             */
            if (this.selected > 0 && (this.selected <= j && j < this.active) || (this.selected > j && j >= this.active)) {
                this.context.fillStyle = this.colors[this.WAVE_SELECTED];
            }
            else if (this.active > j) {
                this.context.fillStyle = this.colors[this.WAVE_ACTIVE];
            }
            else {
                this.context.fillStyle = this.colors[this.WAVE_FOCUS];
            }
            this.context.fillRect(xPos, yPos, this.waveWidth, d);
            /*
            draw the gutter
             */
            if (this.selected > 0 && (this.selected <= j && j < this.active) || (this.selected > j && j >= this.active)) {
                this.context.fillStyle = this.colors[this.GUTTER_SELECTED];
            }
            else if (this.active > j) {
                this.context.fillStyle = this.colors[this.GUTTER_ACTIVE];
            }
            else {
                this.context.fillStyle = this.colors[this.GUTTER];
            }
            gutterX = Math.max(d, dNext);
            this.context.fillRect(xPos + this.waveWidth, yPos, this.gutterWidth, gutterX);
            /*
             draw the reflection
             */
            if (this.reflection > 0) {
                reflectionHeight = Math.abs(d) / (1 - this.reflection) * this.reflection;
                if (this.active > i) {
                    this.context.fillStyle = this.colors[this.REFLECTION_ACTIVE];
                }
                else {
                    this.context.fillStyle = this.colors[this.REFLECTION];
                }
                this.context.fillRect(xPos, yPos, this.waveWidth, reflectionHeight);
            }
            xPos += this.waveWidth + this.gutterWidth;
            results.push(j++);
        }
        return results;
    };
    ;
    Waveform.prototype.clear = function () {
        this.context.fillStyle = this.outerColor;
        this.context.clearRect(0, 0, this.width, this.height);
        return this.context.fillRect(0, 0, this.width, this.height);
    };
    ;
    /*
     Data related codes
     */
    Waveform.prototype.setData = function (data) {
        return this.data = data;
    };
    ;
    Waveform.prototype.getData = function () {
        return this.data;
    };
    ;
    Waveform.prototype.setDataInterpolated = function (data) {
        return this.setData(this.interpolateArray(data, this.width));
    };
    ;
    Waveform.prototype.setDataCropped = function (data) {
        return this.setData(this.expandArray(data, this.width));
    };
    ;
    Waveform.prototype.linearInterpolate = function (before, after, atPoint) {
        return before + (after - before) * atPoint;
    };
    ;
    Waveform.prototype.expandArray = function (data, limit, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        var i, j, newData = [], ref;
        if (defaultValue === null) {
            defaultValue = 0;
        }
        if (data.length > limit) {
            newData = data.slice(data.length - limit, data.length);
        }
        else {
            i = j = 0;
            ref = limit - 1;
            while ((0 <= ref ? j <= ref : j >= ref)) {
                newData[i] = data[i] || defaultValue;
                i = (0 <= ref ? ++j : --j);
            }
        }
        return newData;
    };
    ;
    Waveform.prototype.interpolateArray = function (data, fitCount) {
        var after, atPoint, before, i, newData = [], springFactor, tmp;
        springFactor = (data.length - 1) / (fitCount - 1);
        newData[0] = data[0];
        i = 1;
        while (i < fitCount - 1) {
            tmp = i * springFactor;
            before = Math.floor(tmp);
            after = Math.ceil(tmp);
            atPoint = tmp - before;
            newData[i] = this.linearInterpolate(data[before], data[after], atPoint);
            i++;
        }
        newData[fitCount - 1] = data[data.length - 1];
        return newData;
    };
    ;
    Waveform.prototype.putDataIntoWaveBlock = function () {
        var data, fAbsValue, fAverage, fWavePoint, i, iWaveBlock, iWaveCount, j, key, newDataBlocks, sum;
        iWaveBlock = this.waveWidth + this.gutterWidth;
        data = this.getData();
        newDataBlocks = [];
        iWaveCount = Math.ceil(data.length / iWaveBlock);
        i = 0;
        while (i < iWaveCount) {
            sum = 0;
            j = 0;
            while (j < iWaveBlock) {
                key = (i * iWaveBlock) + j;
                sum += data[key];
                j++;
            }
            fAverage = sum / iWaveBlock;
            fAbsValue = fAverage * this.waveHeight;
            fWavePoint = Math.floor(-Math.abs(fAbsValue));
            newDataBlocks.push(fWavePoint);
            i++;
        }
        return newDataBlocks;
    };
    ;
    Waveform.prototype.cache = function () {
        if (this.interpolate === false) {
            this.setDataCropped(this.data);
        }
        else {
            this.setDataInterpolated(this.data);
        }
        this.wavesCollection = this.putDataIntoWaveBlock();
    };
    ;
    /*
      Data update details here
     */
    Waveform.prototype.update = function (options) {
        if (options) {
            if (options.gutterWidth) {
                this.gutterWidth = options.gutterWidth;
            }
            if (options.waveWidth) {
                this.waveWidth = options.waveWidth;
            }
            if (options.width) {
                this.width = options.width;
                this.canvas.width = this.width;
            }
            if (options.height) {
                this.height = options.height;
                this.canvas.height = this.height;
            }
            if (options.reflection === 0 || options.reflection) {
                this.reflection = options.reflection;
            }
            if (options.interpolate) {
                this.interpolate = options.interpolate;
            }
            /*
              Re-calculate the wave block formations once one of the following is altered
             */
            if (options.gutterWidth || options.waveWidth || options.width || options.height || options.reflection || options.interpolate || options.reflection === 0) {
                this.cache();
            }
            if (options.height || options.reflection || options.reflection === 0) {
                this.updateHeight();
            }
        }
        this.redraw();
    };
    ;
    return Waveform;
}(event_emitter_1.EventEmitter));
exports.Waveform = Waveform;
